import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useInactivityRedirect = (timeoutMinutes = 30) => {
  const navigate = useNavigate();
  const timeoutMs = timeoutMinutes * 60 * 1000;

  useEffect(() => {
    let timeoutId;

    const resetTimer = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        // Properly log out the user
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login');
      }, timeoutMs);
    };

    // Reset timer on any user activity
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    events.forEach(event => {
      window.addEventListener(event, resetTimer, true);
    });

    // Initialize the timer
    resetTimer();

    // Cleanup
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      events.forEach(event => {
        window.removeEventListener(event, resetTimer, true);
      });
    };
  }, [navigate, timeoutMs]);

  return null; // This hook doesn't return anything
};

export default useInactivityRedirect;